import Layout from "../components/Layout/Layout.react";
import JobBoard from "../components/GlobalJobBoard/JobBoard";
import {
  getFunctionalAreaFacets,
  getLocationFacets,
  listJobs,
} from "../lib/server/hirexlGlobalJobBoardClient";

function value(query, name) {
  const raw = query[name];
  return (Array.isArray(raw) ? raw[0] : raw || "").toString().slice(0, 200);
}

export default function JobsPage(props) {
  return (
    <Layout title="Find jobs | HireXL" description="Browse eligible jobs and apply directly.">
      <JobBoard {...props} />
    </Layout>
  );
}

export async function getServerSideProps({ query }) {
  const initialFilters = {
    q: value(query, "q"),
    location: value(query, "location"),
    functionalArea: value(query, "functionalArea"),
    secondaryFunctionalArea: value(query, "secondaryFunctionalArea"),
    page: Math.max(1, Number.parseInt(value(query, "page"), 10) || 1),
  };
  const filters = {
    q: initialFilters.q || undefined,
    location: initialFilters.location || undefined,
    functionalArea: initialFilters.functionalArea ? initialFilters.functionalArea.split(",").filter(Boolean) : undefined,
    secondaryFunctionalArea: initialFilters.secondaryFunctionalArea ? initialFilters.secondaryFunctionalArea.split(",").filter(Boolean) : undefined,
  };
  try {
    const [initialJobs, initialLocations, initialFunctionalAreas] = await Promise.all([
      listJobs({ ...filters, page: initialFilters.page, limit: 15 }),
      getLocationFacets({ ...filters, page: initialFilters.page, limit: 15 }),
      // Keep the full facet catalog available in the sidebar. Applying the
      // active functional-area filter here would hide all other options.
      getFunctionalAreaFacets(),
    ]);
    return { props: { initialJobs, initialLocations, initialFunctionalAreas, initialFilters } };
  } catch {
    return {
      props: {
        initialJobs: { hits: [], offset: 0, limit: 15, estimatedTotalHits: 0, processingTimeMs: 0, query: "" },
        initialLocations: [],
        initialFunctionalAreas: [],
        initialFilters,
        initialError: true,
      },
    };
  }
}
